var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "service-switch-type-modal" },
      on: {
        click: function ($event) {
          _vm.show = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "service-switch-type-box",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "service-switch-type-label" }, [
            _vm._v(_vm._s(_vm.$t("servicetype.label"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-container" }, [
            _c("div", { staticClass: "grid-x grid-padding-x" }, [
              _c(
                "div",
                { staticClass: "large-12 medium-12 small-12 cell centered" },
                [
                  _c(
                    "div",
                    { staticClass: "grid-x grid-padding-x" },
                    [
                      _vm._l(_vm.workroomTypes, function (workroomType) {
                        return (workroomType.ID == 20 &&
                          _vm.maintenanceIncluded == true) ||
                          workroomType.ID == 60
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "large-12 medium-12 small-12 cell service-switch-type-content",
                              },
                              [
                                workroomType.WorkType == "Údržba"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "service-switch-type-button",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.submitType(
                                              workroomType.ID
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("servicetype.maintenance")
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                workroomType.WorkType == "Pneumatiky"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "service-switch-type-button",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.submitType(
                                              workroomType.ID
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("servicetype.tires"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.maintenanceIncluded == true
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "large-12 medium-12 small-12 cell service-switch-type-content",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "service-switch-type-button",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.submitCallingAction(20)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("servicetype.callingAction")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "large-12 medium-12 small-12 cell service-switch-type-content",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "service-switch-type-button",
                              attrs: { type: "submit" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitChargingStations()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("servicetype.chargingStation"))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }